import React, {Component} from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import * as VideoActions from '../../store/actions/videoActions';
import moment from 'moment';

class Logs extends Component {
    constructor(props){
        super(props);

        let options = [];
        for(let i = 0; i < 12; i++){
            let d = moment().subtract(i, 'months');
            options.push({
                begin: d.format('YYYY-MM-01'),
                end: d.add(1, 'months').format('YYYY-MM-01')
            })
        }

        this.state = {
            begin: moment(),
            end: moment(),
            options: options,
            selected: 0
        }
    }

    componentDidMount(){
        if(this.props.match.params.courseUserId){
            this.props.getLogs(this.props.match.params.courseUserId, this.state.options[0], this.props.user.id);
        }
    }

    updateDate = (e) => {
        this.setState({selected: e.target.value}, () => {
            this.props.getLogs(this.props.match.params.courseUserId, this.state.options[this.state.selected], this.props.user.id);
        });
    }

    render(){
        return (
            <div id="content-container" className="content-wrapper">
            <section className="content">
            <div className="row">
                <div className="col-sm-12">
  
                    <div className="panel customPanel">

                    	<div className="panel-body no-padding darkest-panel" style={{background: "#181818 !important"}}>


                    <div className="sp-20">
                        <div className="clearfix">
                            <div className="RFH">
                                <div>
                                    <p className="font-24 text-white sm-bottom30">Activity Log</p>
                                </div>
                                <div>
                                    <select className="form-control" value={this.state.selected} onChange={e => this.updateDate(e)}>
                                        {this.state.options.map((o, i) => {
                                            return <option value={i} key={i}>{moment(o.begin).format('MMM YYYY')}</option>
                                        })}
                                    </select>
                                </div>
                            </div>

                        </div>

                        <table className="table" style={{background: "#181818"}}>
                            <tbody>
                            <tr role="row" className="odd">
                                <td className="sorting_1">Date</td>
                                <td>Duration</td>
                                <td>Type</td>
                                <td>Subject</td>
                                <td>Chapter</td>
                                <td>Activity</td>
                                <td>Score</td>
                            </tr>

                            {this.props.logs.map((l, i) => {
                                let ms = moment(l.end).diff(moment(l.date));
                                let d = moment.duration(ms);
                                return (
                                    <tr role="row" className="odd" key={i}>
                                        <td className="sorting_1">{moment(l.date).format('YYYY-MM-DD')}</td>
                                        <td>{l.end ? d.humanize() : 'a few seconds'}</td>
                                        <td>{l.type}</td>
                                        <td>{l.Subject ? l.Subject.name : '-'}</td>
                                        <td>{l.Chapter ? l.Chapter.name : '-'}</td>
                                        <td><span className="tag-wrap">{l.activity ? l.activity : '-'}</span></td>
                                        <td><span className="tag-wrap">{l.score ? l.score : 'NA'}</span></td>
                                    </tr>
                                )
                            })}
                            
                            </tbody>
                            </table>
                        </div>
                    </div>

                </div>
            </div>
            </div>

        </section>
        </div>
        )
    }
}

const mapStateToProps = (state) => ({
    ...state.auth,
    ...state.video
});

const mapDispatchToProps = (dispatch) => ({

    getLogs: (cu, range, token) => {
        dispatch(VideoActions.getLogs(cu, range, token));
    }
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(Logs));


// WEBPACK FOOTER //
// ./src/components/StudentProfile/Logs.js